import IProductSku from "../entities/IProductSku";
import Axios from "./Axios";
import ENDPOINTS from "./endpoints";

const getProductWithCategoryVariant = (categoryId: number, productId: number) => {
  return Axios.get<any>(
    ENDPOINTS.products.withCategoryVariant(categoryId, productId)
  );
};

const getAllSkus = () => {
  return Axios.get<any>(ENDPOINTS.productSku.all);
};

const getSkusByProductId = async (productId: number): Promise<IProductSku[]> => {
  const res = await getAllSkus();
  const body: any = (res as any)?.data ?? res;
  const list: any[] = Array.isArray(body) ? body : body?.data ?? body?.content ?? [];
  return (Array.isArray(list) ? list : []).filter(
    (sku: any) =>
      sku?.productId === productId && (sku?.isActive === 1 || sku?.isActive === true)
  );
};

const createProductSku = (data: Partial<IProductSku>) => {
  return Axios.post<IProductSku>(ENDPOINTS.productSku.create, data);
};

const updateProductSku = (skuId: number, data: Partial<IProductSku>) => {
  return Axios.put<IProductSku>(ENDPOINTS.productSku.update(skuId), data);
};

const deleteProductSku = (skuId: number) => {
  return Axios.delete(ENDPOINTS.productSku.delete(skuId));
};

const updateThumbnail = (productId: number, thumbnail: string) => {
  return Axios.patch(ENDPOINTS.productSku.updateThumbnail(productId), { thumbnail });
};

const updatePrice = (productId: number, price: number) => {
  return Axios.patch(ENDPOINTS.productSku.updatePrice(productId), { price });
};

const ProductSkuService = {
  getProductWithCategoryVariant,
  getAllSkus,
  getSkusByProductId,
  createProductSku,
  updateProductSku,
  deleteProductSku,
  updateThumbnail,
  updatePrice,
};

export default ProductSkuService;
